import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty2 } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "a46d2ZbmLVLBIIao4PT8OCD", "Cfg", undefined);

var Cfg = /*#__PURE__*/function () {
  function Cfg() {
    _defineProperty2(this, "_magnetismStep", 25);

    _defineProperty2(this, "_accelerateStep", 33);
  }

  var _proto = Cfg.prototype;

  _proto.start = function start() {};

  _proto.parseData = function parseData(items) {};

  _createClass(Cfg, null, [{
    key: "I",
    get: function get() {
      if (!Cfg._instance) {
        Cfg._instance = new Cfg();
      }

      return Cfg._instance;
    }
    /**吸铁石等级 */

  }]);

  return Cfg;
}();

_defineProperty2(Cfg, "_instance", null);

export { Cfg as default };
export var Cfg_Achieve = function Cfg_Achieve(info) {
  _defineProperty2(this, "Id", 0);

  _defineProperty2(this, "Condition", "");

  _defineProperty2(this, "Reward", "");

  var props = Object.getOwnPropertyNames(this);
  var keys = Object.keys(info);

  for (var i = 0; i < keys.length; i++) {
    if (props.indexOf(keys[i]) != -1) {
      _defineProperty(this, keys[i], info[keys[i]]);
    }
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

_cclegacy._RF.pop();